import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "../../lib/utils"

const Checkbox = React.forwardRef<
    React.ElementRef<typeof CheckboxPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, checked, ...props }, ref) => {
    const isChecked = checked === true || checked === "indeterminate";

    return (
        <CheckboxPrimitive.Root
            ref={ref}
            checked={checked}
            className={cn(
                "peer h-5 w-5 shrink-0 rounded border bg-card ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 relative",
                isChecked
                    ? "bg-primary border-primary text-primary-foreground"
                    : "border-border",
                className
            )}
            {...props}
        >
            {isChecked && (
                <CheckboxPrimitive.Indicator
                    className={cn("flex items-center justify-center text-current")}
                >
                    <Check className="h-4 w-4" />
                </CheckboxPrimitive.Indicator>
            )}
        </CheckboxPrimitive.Root>
    );
})
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
